import Home from "./Home";
import About from "./About";
import ELearning from "./ELearning";
import Simulators from "./Simulators";
import Training from "./Training";
import HseManagement from "./HseManagement";
import Blog from "./Blog";
import Trajectory from "./Trajectory";
import Contact from "./Contact";
import BlogDetails from "./BlogDetails";

const routes = [
  { path: '/', component: <Home /> },
  { path: '/about', component: <About /> },
  { path: '/e-learning', component: <ELearning /> },
  { path: '/simulators', component: <Simulators /> },
  { path: '/training', component: <Training /> },
  { path: '/hse-management', component: <HseManagement /> },
  { path: '/blog', component: <Blog /> },
  { path: '/trajectory', component: <Trajectory /> },
  { path: '/contact', component: <Contact /> },
  { path: '/blog_details/:id', component: <BlogDetails /> }, // Cambiado a /blog_details/:id
];

export default routes;